export const TEST_ENVIRONMENT = false;
export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const VIEWPORT_RATIO = 0.98;

export const API_DOMAIN = 'https://test-qa.dotag.com';
export const STRIPE_KEY = 'pk_test_51HwQqvAGt1rrMKDLoTukMXTNPuahGRq1887m6jHue44pc8qLLrs1N0o6v0IYrabXg8YYtGgeMhmzsz72hpvJiZwu00IrbBPfGL';
export const MAX_WIDTH = 2048;
export const MAX_HEIGHT = 2048;

// Download Options
export const INITIAL_DELAY = 500; //ms
export const MAX_RETRIES = 3;
export const BACK_OFF_FACTOR = 2;// Multiplier for retry delay

// PDF size
export const PDF_DIMENSION = 8000;